import { Store } from 'pullstate';
import { PuzzleStoreBase, PuzzleStoreBaseDefaults } from '../../../utils/types';
import { GridState, makeEmptyGrids } from './geometry';

export type UltrarubigramStoreType = PuzzleStoreBase & {
  /** How far the whole puzzle has been turned. Degrees, cumulative, a multiple of 90. */
  rot: number;
  /** The four 12x12 grids (TL, TR, BL, BR), each holding four 6x6 quadrants of four 3x3 subgrids. */
  grids: GridState[];
  /** The solved 24x24. */
  solution: string[][];
  /** True while the reveal animation is playing the puzzle to its solution. */
  isRevealing: boolean;
  /** True during the final spin of the victory animation (see .celebrating). */
  isCelebrating: boolean;
};

export const UltrarubigramStore = new Store<UltrarubigramStoreType>({
  ...PuzzleStoreBaseDefaults,
  rot: 0,
  grids: makeEmptyGrids(),
  solution: [],
  isRevealing: false,
  isCelebrating: false,
});
